<template>
  <div class="related-row">
    <div class="table-container">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="relatedRow"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @edit-closed="closeEditTableHandler"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <!-- <template v-slot:edit="{ row }">
            <inputNumberAd
              v-model="row[item.field]"
              v-if="item.editRender.name == 'amountRound'"
              :controls="false"
              class="inputWidth"
              :disabled="!isCreate"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumberAd>
          </template> -->
          <template v-slot="{ row }">
            <template v-if="item.field === 'settlementBusinessType'">{{
              businessCategory?.find((item) => item.value == row['settlementBusinessType'])?.label
            }}</template>
            <template v-else-if="item.field === 'settlementStatus'">{{
              settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'paymentStatus'">{{
              pay_paymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'printFlag'">{{
              row.printFlag == 1 ? '已打印' : '未打印'
            }}</template>
            <!-- <template v-else-if="item.field === 'businessCategory'">{{
              getSettlementBusinessTypeStatus(row.businessCategory)
            }}</template> -->
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { defaultTableColumn } from './index.js';
  export default {
    name: 'RelatedRow',
    props: {
      preSettlements: {
        type: Array,
        default: () => [],
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
    },
    data() {
      return {
        tableData: [],

        columnList: defaultTableColumn,
        selectionList: [],
      };
    },
    watch: {
      preSettlements: {
        handler(val) {
          this.fullFetchTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    computed: {
      // searchFormColumns() {
      //   return searchColumns(this);
      // },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      pay_paymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
      //校验
      validRules() {
        const amountValid = (rule, value, callback, { row }) => {
          //冲销数量≤结算数量
          console.log(rule, value);
          if (row.writeOffPreNum > row.settlementQuantity) {
            callback(new Error('冲销数量≤结算数量'));
          } else {
            callback();
          }
        };
        return {
          writeOffPreNum: [
            {
              required: true,
              message: '冲销数量必填',
            },
            { validator: amountValid },
          ],
        };
      },
    },
    methods: {
      //插入表格数据
      fullFetchTableData(val) {
        this.$nextTick(() => {
          const $table = this.$refs.relatedRow;
          $table.remove(this.getTableData()); //先删除表格所有数据
          $table?.insertAt(val, 0); // 再插入最新的数据
        });
      },
      async closeEditTableHandler() {
        console.log('关闭');
      },
      getTableData() {
        const $table = this.$refs.relatedRow;
        return $table.getTableData().fullData;
      },
      //选择合同移除所有行
      removeRowHandler() {
        const $table = this.$refs.relatedRow;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(this.selectionList);
        const IdList = this.selectionList.map((item) => item.id);
        this.tableData = this.getTableData().filter((item) => !IdList.includes(item.id));
        this.$emit('deleteTableHandler', IdList, this.selectionList);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.relatedRow;
          let tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid) {
              resolve({ tableData: tableData });
            } else {
              this.$message.error('请检查关联预结算表格数据');
              reject({ tableData: [] });
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .related-row {
    background: #fff;
    .table-container {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
